module.exports = __webpack_public_path__ + "img/login.05bb90d4.jpg";